import { ListTabs, SourceTabs } from "@hooks/useListTabs";

export const allergenCategoryId = 13;

export const parseTabName = (
  input: ListTabs | undefined,
  params: URLSearchParams,
) => {
  if (input === undefined || input === ListTabs.ALL) return;
  if (input === ListTabs.LATEST) params.append(ListTabs.LATEST, "1");
  if (input === ListTabs.FAVORITE) params.append(ListTabs.FAVORITE, "1");
  if (input === ListTabs.GENERIC) params.append(ListTabs.GENERIC, "1");
  if (input === ListTabs.SYNONYMS) params.append(ListTabs.SYNONYMS, "1");
  if (input === ListTabs.UNVERIFIED) params.append("reviewed", "0");
  if (input === ListTabs.ALLOWEAT) params.append("source", SourceTabs.ALLOWEAT);
  if (input === ListTabs.OWN) params.append("source", SourceTabs.CLINIC);
  if (input === ListTabs.COMMON_CLINIC)
    params.append("source", SourceTabs.COMMON_CLINIC);
  if (input === ListTabs.MOTHER_CLINIC)
    params.append("source", SourceTabs.MOTHER_CLINIC);
};
export const dietTypeId = 32;

export const parseNumber = (
  input: number | undefined | null,
  name: string,
  params: URLSearchParams,
) => {
  if (input !== undefined && input !== null) {
    params.append(name, input.toString());
  }
};

export const parseString = (
  input: string | undefined | null,
  name: string,
  params: URLSearchParams,
) => {
  if (input !== undefined && input !== null && !!input.trim()) {
    params.append(name, input.trim());
  }
};

export const parseTagsList = (
  input: string[] | undefined,
  params: URLSearchParams,
) => {
  if (input !== undefined && !!input.length) {
    params.append(
      "tags",
      [...input]
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map(t => t.toString())
        .join(","),
    );
  }
};

export const parseNutrientsList = (
  input: Record<string, [number | null, number | null]> | undefined,
  params: URLSearchParams,
  defaults?: Record<string, [number, number]>,
) => {
  const ranges: string[] = [];

  for (const [id, range] of Object.entries(input ?? {})) {
    if (!range) continue;
    const [min, max] = range;
    const baseline = defaults?.[id];

    if (baseline && baseline[0] === min && baseline[1] === max) continue;
    if (!min && !max) continue;
    if (
      (min !== null && (!Number.isFinite(min) || min < 0)) ||
      (max !== null && (!Number.isFinite(max) || max < 0))
    ) {
      continue;
    }

    ranges.push(`${id}|${min ?? null}|${max ?? null}`);
  }

  if (ranges.length) params.append("nutrients", ranges.join(","));
};

export const parseBooleanString = (
  input: "0" | "1" | undefined,
  name: string,
  params: URLSearchParams,
) => {
  if (!input || input === "0") return;

  return params.append(name, "1");
};

export const parseCategory = (
  input: string[] | string | null | undefined,
  name: string,
  params: URLSearchParams,
) => {
  if (!input || !input[0]) return;

  return params.append(name, input[0]);
};

export const parseStringArrayNew = (
  input: string[] | undefined,
  name: string,
  params: URLSearchParams,
) => {
  if (input !== undefined && !!input.length) {
    params.append(
      name,
      [...input].sort((a, b) => parseInt(a) - parseInt(b)).join(","),
    );
  }
};
